// Certificate designs

export const NEW_CERTIFICATE_DESIGNS = {
  WHITE: 'white',
  GREEN: 'green',
  LIME: 'lime',
  PINK: 'pink',
};

export const NEW_CERTIFICATE_BACKGROUNDS = {
  white: '#fff',
  green: '#c4eee3',
  lime: '#d2ff1f',
  pink: '#ffe1fb',
};

export const CERTIFICATE_DESIGNS = {
  // BLUE: {
  blue: {
    background: '#009EE2',
    picture: '#2D2E83',
    ornament: '#009EE2',
    amount: '#005FAF',
  },
  // DARK_BLUE: {
  darkblue: {
    background: '#02183E',
    picture: '#007CAB',
    ornament: '#004378',
    amount: '#041230',
  },
  // GOLD: {
  gold: {
    background: '#EFD36F',
    picture: '#B07E00',
    ornament: '#9E6B00',
    amount: '#9E6B00',
  },
  // STONE: {
  grey: {
    background: '#D9D7C8',
    picture: '#989689',
    ornament: '#868576',
    amount: '#868576',
  },
};

export const FAQ_ITEMS = [
  {
    question: 'Как использовать сертификат?',
    answer: `Чтобы использовать сертификат, нужно:
        — Зайти на сайт level.travel или скачать мобильное приложение.
        — Указать направление, количество человек и дату вылета.
        — Сравнить предложения, выбрав подходящий вариант.
        — Ввести номер сертификата в поле «Промокод» при оплате тура.`,
  },
  {
    question: 'Какой у сертификата срок действия?',
    answer: 'Сертификат действителен в течение года с момента приобретения.',
  },
];

export const PRICE_PRESETS = [35000, 70000, 120000];

export const SHIPPING_TYPE_EMAIL = 'email';
export const SHIPPING_TYPES = [
  {
    label: 'Отправить мне на email',
    value: SHIPPING_TYPE_EMAIL,
  },
];

// ERR_CODES
export const NO_ATTACHMENT_ERROR = 'no_attachment_error';

// MISC
export const CERTIFICATE_DOWNLOAD_MAX_RETRY = 3;
